// extracted by mini-css-extract-plugin
export default {"content":"ChangePasswordModal-module__content--_DcPB","passwordPolicy":"ChangePasswordModal-module__passwordPolicy--pe8G5"};